import React from 'react';
import Link from './Link';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import {selectQuickLinks} from '../../../selectors';
import {useGetMessages} from '../../../hooks';
import {Skeleton} from '@material-ui/lab';

const Box = styled.ul`
    display: flex;
    justify-content: flex-end;
    padding: 0;
    margin: 0;
    list-style-type: none;
    margin-top: 20px;
    & > li {
        &:not(:first-child)::before {
            content: '•';
            position: relative;
            top: 1px;
            margin: 0 10px;
            color: ${p => p.theme.muiTheme.palette.grey[400]};
        }
    }
`;

export interface HelpLinksProps {
    isLoading?: boolean;
}

const HelpLinks: React.FC<HelpLinksProps> = ({isLoading = false}) => {
    const quickLinks = useSelector(selectQuickLinks);
    const messages = useGetMessages({
        privacyPolicy: 'epic.affiliate.common.privacyPolicy',
        contactSupport: 'epic.affiliate.common.contactSupport'
    });

    const links = [
        {
            to: quickLinks.contactSupport,
            label: messages.contactSupport
        },
        {
            to: quickLinks.privacyPolicy,
            label: messages.privacyPolicy
        }
    ];

    return (
        <Box>
            {isLoading ? (
                <Skeleton height={30} width="100%" />
            ) : (
                links.map((link, index) => (
                    <li key={index}>
                        <Link to={link.to} underline="none" color="primary" variant="caption">
                            {link.label}
                        </Link>
                    </li>
                ))
            )}
        </Box>
    );
};

export default HelpLinks;
